
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// Ensure React is loaded before React-DOM tries to use it
if (!window.React) {
  window.React = React;
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error('Root element not found');
}

try {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('Failed to initialize app:', error);
  // Show error in UI for production
  rootElement.innerHTML = `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; font-family: system-ui, sans-serif; padding: 20px; text-align: center;">
      <h1 style="color: #dc2626; margin-bottom: 16px;">Application Failed to Load</h1>
      <p style="color: #6b7280; margin-bottom: 24px;">We're experiencing technical difficulties. Please refresh the page.</p>
      <button onclick="window.location.reload()" style="background: #3b82f6; color: white; padding: 12px 24px; border: none; border-radius: 8px; cursor: pointer; font-size: 16px;">
        Refresh Page
      </button>
    </div>
  `;
}
